import NotificationBanners from '../NotificationBanners';
import { useBannerNotifications } from '../../hooks/useNotifications';

const NotificationBannersApp = () => {
    const { bannerNotifications, loading, setNotificationRead, getPlugin } = useBannerNotifications();

    return <NotificationBanners
        notifications={bannerNotifications}
        loading={loading}
        setNotificationRead={setNotificationRead}
        getPlugin={getPlugin}
    />;
};

export default NotificationBannersApp;
